import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import APIURL from "../../common/Config";
import "../blog/Blog.css";

const formatScheduleDate = (numDate) => {
  if (!numDate) return "Invalid date";
  const dateStr = String(numDate);
  if (dateStr.length !== 8) return "Invalid date";
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const day = dateStr.slice(6, 8);
  return `${day}/${month}/${year}`;
};

const slugify = (text) =>
  (text ?? "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardsPerSlide = 3;

  const staticMeta = {
    title:
      "Latest Astrology Blogs – Daily Horoscopes, Remedies & Zodiac Insights | AstroBhagya",
    description:
      "Discover the latest astrology blogs from AstroBhagya, including daily horoscopes, zodiac predictions, and spiritual remedies. Explore personalized astrological guidance for a balanced life.",
    keywords:
      "AstroBhagya astrology blogs, daily horoscope blog, zodiac predictions, astrology remedies, personalized horoscope, Vedic astrology blog",
    author: "Heavenly Expectation Private Limited",
    revisitAfter: "90 days",
    distribution: "global",
    rating: "general",
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true); 
      setError(null);

      const todayFormatted = new Date()
        .toISOString()
        .split("T")[0]
        .replace(/-/g, "");

      try {
        const response = await fetch(
          `${APIURL}/astroblogs/by-date?startDate=20250101&endDate=${todayFormatted}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const blogsList = data
          .filter((blog) => blog.heading)
          .map((blog) => ({
            ...blog,
            slug: slugify(blog.heading),
            scheduleDateFormatted: blog.scheduleDate,
          }))
          .filter((blog) => blog.scheduleDate <= Number(todayFormatted))
          .sort((a, b) => b.scheduleDate - a.scheduleDate);

        setBlogs(blogsList);
      } catch (err) {
        console.error("Error fetching blog data:", err);
        setError(err.message);
      } finally {
        setLoading(false); 
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {
    document.title = staticMeta.title;

    const setOrCreateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };

    setOrCreateMetaTag("description", staticMeta.description);
    setOrCreateMetaTag("keywords", staticMeta.keywords);
    setOrCreateMetaTag("author", staticMeta.author);
    setOrCreateMetaTag("revisit-after", staticMeta.revisitAfter);
    setOrCreateMetaTag("distribution", staticMeta.distribution);
    setOrCreateMetaTag("rating", staticMeta.rating);

    let charsetMeta = document.querySelector("meta[charset]");
    if (!charsetMeta) {
      charsetMeta = document.createElement("meta");
      charsetMeta.setAttribute("charset", "UTF-8");
      document.head.prepend(charsetMeta);
    }
  }, []);

  const visibleBlogs = blogs.slice(currentIndex, currentIndex + cardsPerSlide);

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev + cardsPerSlide >= blogs.length ? 0 : prev + cardsPerSlide
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev - cardsPerSlide < 0
        ? blogs.length - cardsPerSlide
        : prev - cardsPerSlide
    );
  };

 
  if (loading) {
    return (
      <div
        className="loader-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <div
          className="spinner"
          style={{
            border: "4px solid rgba(0, 0, 0, 0.1)",
            borderTop: "4px solid #3498db",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            animation: "spin 1s linear infinite",
          }}
        />
        <p style={{ marginTop: "10px", fontSize: "1.2em", color: "#555" }}>
          Loading blogs...
        </p>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (error) return <p>Error: {error}. Please try again later.</p>;
  if (blogs.length === 0)
    return <p>No blogs available at the moment. Please check back later.</p>;

  return (
    <div className="container-fluid">
      <h2 className="blog-title">BLOG UPDATES YOU CAN'T MISS</h2>
      <div className="carousel-container">
        <div className="carousel-track">
          {visibleBlogs.map((blog) => (
            <div
              key={blog.id}
              className="carousel-slide"
              onClick={() => navigate(`/blog/${blog.slug}`)}
            >
              <img
                src={blog.mainImageUrl}
                alt={blog.mainHeading || "Blog image"}
                className="blog-image"
              />
              <div className="blog-content">
                <h3>{blog.mainHeading}</h3>
                <div className="author-date">
                  <p className="author">{blog.article}</p>
                  <p className="date">
                    {formatScheduleDate(blog.scheduleDate)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <button className="prev-button" onClick={handlePrev}>
          &#10094;
        </button>
        <button className="next-button" onClick={handleNext}>
          &#10095;
        </button>
        <div className="view-more">
          {/* <button
            className="btn btn-primary"
            onClick={() => navigate("/blogs")}
          >
            View More
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Blog;